import { TradingPair } from "shared/model";
import { sortPairs } from "./sortPairs";

/** Cold start: первая market-open пара по sortPairs; иначе — первая из списка. */
export const pickFirstMarketOpenPair = (
  currencyPairs: TradingPair[],
): string | null => {
  if (currencyPairs.length === 0) return null;

  const open = sortPairs(currencyPairs.filter((p) => p.isMarketOpen));
  return open[0]?.symbol ?? sortPairs(currencyPairs)[0]?.symbol ?? null;
};
